import React from 'react';
import { withStyles } from '@mui/styles';
import Grid from '@mui/material/Grid';
import Slider from '@mui/material/Slider';
import Input from '@mui/material/Input';
import Typography from '@mui/material/Typography';
import Compass from './Compass'


class CompassControl extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
          degrees: this.props.degrees ? this.props.degrees : 0,
          width: this.props.width ? this.props.width : 100,
          origprops: this.props,

        }
    }

    handleSliderChange = (event, newValue) => {
        if(newValue<=175) {
            this.setState({degrees: newValue})
            this.props.onChange({degrees: newValue})
        }
    };
    
    handleInputChange = (event) => {
        let degrees = event.target.value
        if( this.state.origprops.degrees !== this.props.degrees) {
            degrees = this.props.degrees
        }
        this.setState({degrees: degrees === '' ? 0 : Number(degrees), origprops: this.props})
        this.props.onChange({degrees: degrees})
    };
    
    handleBlur = () => {
        if (this.state.degrees < 0) {
          this.setState({degrees: 0});
        } else if (this.state.degrees > 175) {
          this.setState({degrees: 175});
        }
    };

    static getDerivedStateFromProps(nextProps, prevState) {
        // do things with nextProps.someProp and prevState.cachedSomeProp
        if(prevState.origprops.degrees !== nextProps.degrees)
          return {
            origprops: nextProps,
            degrees:  nextProps.degrees,
            // ... other derived state properties
        };
        return null
    }

    render() {
        const { classes } = this.props;
        return (
            <div className={classes.root} >
                <Compass degrees={this.state.degrees} />
                <Typography id="input-slider"  style={{marginLeft: 5, fontSize: 10, marginTop: 5}} >
                    Degree from South
                </Typography  >
                <Grid container spacing={2} alignItems="center" > 
                    <Grid item xs>
                        <Slider
                            value={typeof this.state.degrees === 'number' ? this.state.degrees : Number(this.state.degrees)}
                            onChange={this.handleSliderChange}
                            aria-labelledby="input-slider-compass" 
                            min={0} 
                            max={175} 
                            step={5} 
                            style={{marginLeft: 5}}
                        />
                    </Grid>
                    <Grid item>
                        <Input
                            className={classes.input}
                            value={this.state.degrees  ? this.state.degrees : 0}
                            margin="dense"
                            onChange={this.handleInputChange}
                            inputProps={{
                                step: 5,
                                min: 0,
                                max: 175,
                                type: 'number',
                                'aria-labelledby': 'input-slider-compass',
                            }}
                        />
                    </Grid>
                </Grid>
            </div>                        
        );
    }
}

//let theme = createMuiTheme();
//theme = responsiveFontSizes(theme);

const styles = theme => ({
    root: {
      width: 140,
      marginTop: 10,
    },
    input: {
      width: 40,
      fontSize: 12,
    },
    indent: {
      marginLeft: 20,
  
    }
});

export default withStyles(styles, { withTheme: true })(CompassControl);
